import { Controller } from "stimulus"

const COLLAPSED_MAX_HEIGHT = 400

export default class extends Controller {
    static targets = ['holder', 'toggle', 'label']

    connect() {
        requestAnimationFrame(() => this.measure())
        window.addEventListener('resize', this.onResize)
    }

    disconnect() {
        window.removeEventListener('resize', this.onResize)
    }

    onResize = () => {
        if (this.element.classList.contains('is-expanded')) {
            return
        }
        this.measure()
    }

    measure() {
        if (!this.hasHolderTarget || !this.hasToggleTarget) {
            return
        }

        const needsCollapse = this.holderTarget.scrollHeight > COLLAPSED_MAX_HEIGHT
        this.element.classList.toggle('is-collapsible', needsCollapse)
        this.toggleTarget.hidden = !needsCollapse

        if (!needsCollapse) {
            this.element.classList.remove('is-expanded')
        }
    }

    toggle(event) {
        event.preventDefault()
        this.element.classList.toggle('is-expanded')

        if (this.hasLabelTarget) {
            const expanded = this.element.classList.contains('is-expanded')
            this.labelTarget.textContent = expanded
                ? this.data.get('collapseLabel')
                : this.data.get('expandLabel')
        }
    }
}
